<script>
	import { createEventDispatcher, onDestroy, onMount } from 'svelte';
	import Icon from './Icon.svelte';

	export let className = 'md:w-2/3 lg:w-1/3 mx-2 md:mx-auto';
	export let bg = true;
	export let prompt = false;

	const dispatch = createEventDispatcher();
	const close = () => dispatch('close');

	let modal;

	const handle_keydown = (e) => {
		if (e.key === 'Escape') {
			close();
			return;
		}

		if (e.key === 'Tab') {
			// trap focus
			const nodes = modal.querySelectorAll('*');
			const tabbable = Array.from(nodes).filter((n) => n.tabIndex >= 0);

			let index = tabbable.indexOf(document.activeElement);
			if (index === -1 && e.shiftKey) index = 0;

			index += tabbable.length + (e.shiftKey ? -1 : 1);
			index %= tabbable.length;

			tabbable[index].focus();
			e.preventDefault();
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			if (previously_focused) {
				previously_focused.focus();
			}
		});
	}

	onMount(() => {
		modal.scrollIntoView();
	});
</script>

<svelte:window on:keydown={handle_keydown} />

<div
	class="fixed inset-0 bg-black cursor-default bg-opacity-50 overflow-y-auto"
	style="margin: 0; padding: 0;"
	role="none"
	on:mousedown|self={close}
	class:z-30={!prompt}
	class:z-40={prompt}
>
	<div
		class="absolute inset-x-0 top-0 flex justify-center mt-12"
		style="max-height: calc(100vh - 6rem);"
		role="none"
		on:mousedown|self={close}
		class:z-40={!prompt}
		class:z-50={prompt}
	>
		<div
			class:bg-white={bg}
			class:p-2={bg}
			class="flex flex-col text-gray-700 rounded {className}"
			role="dialog"
			aria-modal="true"
			bind:this={modal}
		>
			<div class="flex">
				<div class="flex-1 pl-6">
					<slot name="header" />
				</div>
				<button on:click|preventDefault={close} class="self-end">
					<Icon name="close" classes="w-6 h-6 text-gray-700" />
				</button>
			</div>
			<slot />
		</div>
	</div>
</div>
